import { useTranslation } from 'react-i18next'
import CommonTipsContent from './CommonTipsContent'
import { StyledForceRedeemContainer } from '../styled'

interface Props {
  onCloseDepositModal: () => void
  onConfirmRedeemClick: () => void
}

const ForceRedeem: React.FC<Props> = ({
  onCloseDepositModal,
  onConfirmRedeemClick,
}) => {
  const { t } = useTranslation()

  return (
    <StyledForceRedeemContainer>
      <section className="head-title">{t('force_redeem_notice_title')}</section>
      <CommonTipsContent />
      <section className="bottom-btn-area">
        <button className="keep-waiting-btn" onClick={onConfirmRedeemClick}>
          {t('confirm_redeem')}
        </button>
        <button className="confirm-redeem" onClick={onCloseDepositModal}>
          {t('keep_waiting')}
        </button>
      </section>
    </StyledForceRedeemContainer>
  )
}

export default ForceRedeem
